import {request} from './HttpRequestService';
import {storageService} from './storageService';

class AiLogger {
    private appSignature = 'tagging-platform-client';

    async sendLog(msg = '', data:any = {}, type = 'event_log') {
        const msgWithSignature = `[${this.appSignature}] : ${msg}`;

        const dataLog:string = Object.keys(data).length > 0 ? `${msgWithSignature} with data : ${JSON.stringify(data)}` : `${msgWithSignature}`;

        if (storageService.loadFromStorage('token')) {
            try {
                await request.post(storageService.loadFromStorage('token'), 'LOGS', {'msg': dataLog, 'log_type': type});
            } catch (e) {
                console.error(e);
            }
        }
    }
}

export default new AiLogger();
